import { motion } from 'motion/react';
import { Container, Kicker, Mark } from './primitives';
import { Badge } from './ui/badge';

const ITEMS = [
  {
    title: 'Costo esatto, in tempo reale',
    copy: 'Il costo di ogni lavorazione calcolato mentre il cantiere lavora, non ricostruito a fine mese.',
  },
  {
    title: 'Copilota di commessa',
    copy: 'Un assistente interrogabile in linguaggio naturale che conosce la commessa dalla A alla Z — contratto, amministrazione, economico-finanziario, esecuzione.',
  },
  {
    title: 'Suggerimenti operativi',
    copy: 'Cosa fare, quando, con chi — per PM e capicantiere, per facilitare le decisioni di ogni giorno.',
  },
  {
    title: 'Dal vocale al dato strutturato',
    copy: 'Parli, BOSS struttura. In prospettiva, dal vocale al giornale di cantiere in automatico.',
  },
];

export function Vision({ index = '05' }: { index?: string }) {
  return (
    <section className="relative border-t border-border py-28 md:py-36">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3">
            <Kicker index={index} label="La visione" />
            <Badge variant="outline">In arrivo</Badge>
          </div>
          <h2 className="boss-display mt-5 text-balance text-[40px] md:text-[64px]">
            Chiedi alla commessa. <Mark>Ti risponde.</Mark>
          </h2>
          <p className="mt-5 max-w-xl text-pretty text-[16px] leading-[1.55] text-fg-2">
            Non è ancora prodotto — è la direzione in cui stiamo costruendo. Niente date: una roadmap datata
            è una promessa pubblica, e le startup la sforano per definizione.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-2">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-background p-7"
            >
              <h3 className="text-[18px] font-light tracking-tight text-foreground">{it.title}</h3>
              <p className="mt-3 text-pretty text-[13px] leading-[1.6] text-fg-2">{it.copy}</p>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
